import { HAVE_WINDOW } from 'src/constants'

import { dynamicYieldContextPage } from './dynamicYieldContextPage'

const isAMappedPage = (pagePath: string) => {
  const listOfMappedPages = [
    '/',
    '/*slug',
    '/:slug/p',
    '/pesquisa',
    '/pesquisa/',
    '/404',
    '/404/',
    '/checkout/cart/',
  ]

  if (pagePath.includes('/account')) {
    return true
  }

  return listOfMappedPages.includes(pagePath)
}

export default async function dynamicYieldOtherView(pagePath: string) {
  if (isAMappedPage(pagePath) === true || !HAVE_WINDOW) {
    return
  }

  await dynamicYieldContextPage({
    page: 'OTHER',
    data: [window?.location?.href ?? ''],
  })
}
